<template>
  <vs-popup class="create-sundry-supplier-popup"
            id="popup"
            title="VIEW/UPDATE SUNDRY SUPPLIER DOCUMENT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSundryItem)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Document Name</small>
                <vs-input v-model="createForm.name"   name="name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <small class="label">File (.doc, .jpg, .pdf, .jpeg, .png, .docx, .txt)</small>
              <file-uploader
                v-on:onSetFileName="value => createForm.file = value"
                v-on:onClickFileRemove="createForm.file = null"
                :file="createForm.file"
                :condition="true"/>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="comment" name="comment" rules="" v-slot="{ errors }">
                <small class="label">Comment</small>
                <vs-textarea  class="mb-0" v-model="createForm.comment" />
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-sundry-supplier-documents'" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SundrySupplierRepository = RepositoryFactory.get('sundry')
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      createForm: {},
      id: ''
    }
  }

export default {
  name: 'UpdateSundrySupplierDocumentPopUp',
  data () {
    return initialState()
  },
  methods: {
    async openPopup(data) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = data.id
        this.createForm = data
        // await this.fetchSundrySupplierDocument()
        this.open = true;
      } catch (error) {

      }
    },
    async fetchSundrySupplierDocument() {
      this.$vs.loading()
      const {data} = (await SundrySupplierRepository.getSundrySupplierDocument(this.id)).data
      this.createForm = data
      this.$vs.loading.close()
    },
    async onClickCreateSundryItem() {
      const vue = this;
      this.$vs.loading()
      try {
        let payload = Object.assign({}, this.createForm)
        await SundrySupplierRepository.updateSundrySupplierDocument(this.id, payload)
        this.showSuccessMessage('Sundry supplier document updated successfully')
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .create-sundry-supplier-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
</style>
